var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _path7, _circle4, _circle5, _ellipse, _path8, _path9, _path10, _ellipse2, _ellipse3, _path11, _ellipse4, _circle6, _ellipse5, _circle7, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle8, _rect2, _defs, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#5a6270"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#6d7481",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#3f4652"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96L60 124",
    stroke: "#323841",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94L42 78L54 86L60 98L46 104Z",
    fill: "#323841"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 94L78 78L66 86L60 98L74 104Z",
    fill: "#323841"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 88L60 98L68 88L66 84L60 90L54 84Z",
    fill: "#f4f1ea"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98L58 110L60 120L62 110Z",
    fill: "#7a2e35"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 108,
    r: 1.8,
    fill: "#656b74"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 116,
    r: 1.8,
    fill: "#656b74"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 84C50 94 70 94 78 84L80 94C70 102 50 102 40 94Z",
    fill: "#9c3b3b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96L74 116L84 112L78 94Z",
    fill: "#7c2f2f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90L52 92M50 94L58 96",
    stroke: "#7c2f2f",
    strokeWidth: 1.6,
    opacity: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#8a6a3a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#8a6a3a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69Q60 72 68 66",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54C37 80 48 86 60 86S83 80 82 54C80 62 76 66 70 66C66 63 54 63 50 66C44 66 40 62 38 54Z",
    fill: "#6a5030",
    opacity: 0.22
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50C35 29 48 22 60 22S85 29 82 50C78 41 71 35 60 35S42 41 38 50Z",
    fill: "#8a6a3a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44C34 26 48 19 62 20C78 21 88 28 85 44Z",
    fill: "#6b6f5a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20C60 30 58 38 56 44M72 22C74 30 76 38 78 44M48 22C46 30 44 38 42 44",
    stroke: "#535646",
    strokeWidth: 1.2,
    opacity: 0.5,
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58 41C70 38 88 40 96 47C86 52 70 50 58 47Z",
    fill: "#535646"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 21,
    r: 2.6,
    fill: "#535646"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#535646"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait25);
export default __webpack_public_path__ + "static/media/player-portrait-25.a2cdcbca67caabdba42b8614c57eb782.svg";
export { ForwardRef as ReactComponent };